import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { A11y, Navigation, Pagination } from "swiper/core";
import { array, number, string } from "prop-types";
import { useEffect, useState } from "react";

import useMatchMedia from "../../common/useMatchMedia.js";
import ManualEventItem from "./ManualEventItem.jsx";
import cx from "classnames";

const propTypes = {
  index: number,
  pastEvents: array,
  noPastEventsText: string,
};

// TBD if we will end up using this.
// Keeping for now; will delete after client demo if ellipsis cutoff not desired.
// function CompareContainerSize() {
// const [containerHeight, setContainerHeight] = useState({ height: undefined });
// const [leftContentHeight, setLeftContentHeight] = useState({
//   height: undefined,
// });

// useEffect(() => {
//   const containerHeightList = document.queryScurrentLeftectorAll(
//     ".manual-event-item__event-container",
//   );
//   const leftContentHeightList = document.queryScurrentLeftectorAll(
//     ".manual-event-item__left-content",
//   );

// Handler to call on window resize
//     function handleResize() {
//       var index = 0;

//       containerHeightList.forEach(function (container) {
//         var currentLeft = leftContentHeightList[index];
//         // var marginTop = window.getComputedStyle(
//         //   leftContentHeightList[index],
//         // ).marginTop;
//         // var marginBottom = window.getComputedStyle(
//         //   leftContentHeightList[index],
//         // ).marginBottom;

//         var currentOverflow = currentLeft.style.overflow;

//         if (!currentOverflow || currentOverflow === "visible") {
//           currentLeft.style.overflow = "hidden";
//         }

//         var isOverflowing = currentLeft.clientHeight < currentLeft.scrollHeight;
//         currentLeft.style.overflow = currentOverflow;

//         if (isOverflowing) {
//           console.log("overflowing!");
//         }

//         // console.log(marginTop);
//         // console.log(marginBottom);

//         // // Hardcoding margins for now to test
//         // var containerHeight = container.clientHeight - 40 - 35;
//         // var leftContentHeight = leftContentHeightList[index].clientHeight;

//         // console.log(containerHeight);
//         // console.log(leftContentHeight);

//         // if (leftContentHeight > containerHeight) {
//         //   console.log("left content height is greater than container height");
//         //   leftContent.setAttribute("style", "overflow: hidden");
//         // }

//         index++;
//       });
//     }

//     window.addEventListener("resize", handleResize);
//     handleResize();

//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   return;
// }

const ManualEventsListingPast = (props) => {
  const { index, pastEvents, noPastEventsText } = props;

  // For keeping track of whether we are in mobile view;
  // determines if carousel will be displayed
  const matchesMobile = useMatchMedia("(max-width: 745px)");

  const [renderPastSwiper, setRenderPastSwiper] = useState(false);
  useEffect(() => {
    //required to let text load and prevent swiper init errors
    setRenderPastSwiper(true);
  }, []);

  SwiperCore.use([A11y, Pagination, Navigation]);

  return pastEvents.length > 0 ? (
    matchesMobile && pastEvents.length > 1 ? (
      <div className="manual-events-listing__past-swiper">
        {renderPastSwiper && (
          <Swiper
            a11y
            observer={true}
            observeParents={true}
            navigation={
              pastEvents.length > 1
                ? {
                    prevEl: `.manual-events-listing-past__prev-${index}`,
                    nextEl: `.manual-events-listing-past__next-${index}`,
                  }
                : false
            }
            pagination={{ clickable: true }}
            slidesPerView={1}
            spaceBetween={30}
          >
            {pastEvents.map((event, i) => (
              <SwiperSlide key={i}>
                <ManualEventItem {...event} />
              </SwiperSlide>
            ))}
          </Swiper>
        )}
      </div>
    ) : (
      pastEvents?.map((event, i) => <ManualEventItem key={i} {...event} />)
    )
  ) : (
    <p dangerouslySetInnerHTML={{ __html: noPastEventsText }}></p>
  );
};

ManualEventsListingPast.propTypes = propTypes;
export default ManualEventsListingPast;
